import { useQuery, QueryObserverBaseResult } from "react-query"
import { queryKeys } from "../query"
import api, { createUrlParams } from "../client"
import { AddressesResponseData, GetAddressesRequestQuery } from "../types/address"

const getData = async (query: GetAddressesRequestQuery) => {
  try {
    const { data } = await api.get(`/address${createUrlParams(query)}`)
    return data
  } catch ({ response: { data } }) {
    return data
  }
}

export const useAddresses = (query: GetAddressesRequestQuery):
  QueryObserverBaseResult<AddressesResponseData> => {
  const { data, ...props } = useQuery<AddressesResponseData>(
    queryKeys.ADDRESS_LIST(query),
    () => getData(query),
  )
  return { data, ...props }
}
